export default "//cdn.scentbird.com/assets/frontbird-site/images/wine_5529ad.jpg";